import {
    useCallback,
} from 'react'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    useGetRequestSpreadSheetAdapter,
} from 'app/shared-components/SkyNetSpreadSheet'
import StatusHandler from 'app/shared-components/StatusHandler'
import {
    AsyncMutationOptions,
} from 'app/types/request.types'
import {
    useSkyNetPagination,
    SkyNetPaginationContext,
} from 'app/shared-components/SkyNetPagination'

import requests from 'app/requests/RateCard/RateCard.requests'
import useSimpleApiRequest from 'app/hooks/useSimpleApiRequest'
import LogisticsCostsSpreadsheet from '../LogisticsCostsSpreadsheet'
import {
    LogisticsCostsEditable, LogisticsCostsItem,
} from '../LogisticsCosts.types'
import defaultRateCardsBulkSort from '../../RateCardsBulkEdit/RateCardsBulkEdit.utils'

export default function LogisticsCostsBulkEdit({
    onClose,
}: Readonly<{
    onClose: () => void;
}>) {
    const paginationOptions = useSkyNetPagination(100)
    const {
        isError, loaded, error, data, refetch,
    } = useGetRequestSpreadSheetAdapter<LogisticsCostsItem>({
        config: requests.logisticsCostsFilterRequest,
        requestKey: RequestKeys.logisticsCostsFilterRequest,
        enabled: true,
        paginationOptions,
        defaultSort: defaultRateCardsBulkSort,
    })

    const {
        mutateAsync: bulkEdit,
    } = useSimpleApiRequest<{ items: LogisticsCostsEditable[] }>({
        name: 'LogisticsCostsBulkUpdate',
        title: 'Logistics Costs were updated',
        requestParams: requests.logisticsCostsBulkEdit(),
        onSuccess: refetch,
    })

    const onSave = useCallback(
        async (
            items: LogisticsCostsItem[],
            options?: AsyncMutationOptions,
        ) => {
            await bulkEdit({
                items,
            }, {
                ...options,
                onSuccess: options?.onSuccess || onClose,
            })
        },
        [
            bulkEdit,
            onClose,
        ],
    )

    return (
        <StatusHandler
            isError={isError}
            isFetching={!loaded}
            error={error}
            isSuccess={loaded}
        >
            <SkyNetPaginationContext.Provider value={paginationOptions}>
                <LogisticsCostsSpreadsheet
                    data={data}
                    onCancel={onClose}
                    onSave={onSave}
                />
            </SkyNetPaginationContext.Provider>
        </StatusHandler>
    )
}
